import styled from 'styled-components';

interface IContainerProps {
    isOpen?: boolean;
}

export const Container = styled.div<IContainerProps>`
    width: 100%;
`;

export const Controls = styled.button`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    margin: 0;
    border: none;
    background: none;
    user-select: none;
    cursor: pointer;
    font-size: ${({ theme }) => theme.fontSizes[7]};
    line-height: 1.4;
    font-weight: 700;
`;

export const Body = styled.div<IContainerProps>`
    overflow-y: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
    transition: height ${({ theme }) => theme.transitions.hover};
    height: ${({ isOpen }) => (isOpen ? 'fit-content' : 0)};
`;
